// extracted by mini-css-extract-plugin
module.exports = {"container":"EmptyComponent_container__stnhu","title":"EmptyComponent_title__VduPh","description":"EmptyComponent_description__4O1UP"};